'use client';

import Link from '@eliadmin/core/src/components/link';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';

import { GoDownload } from 'react-icons/go';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { Button } from '@eliadmin/core/src/components/ui/button';

export function ProductAccordionAttachments() {
  const isDesktop = useBreakpoint('sm');

  const { t } = useTranslations();
  const product = useVariantsStore(s => s.product);

  if (!product.attachments?.length) return null;

  return product.attachments.map(attachment => (
    <div
      key={attachment.name}
      className="flex w-full items-center justify-between rounded-[4px] bg-[#F9FAFB] p-3"
    >
      <Paragraph>{attachment.name}</Paragraph>
      <Button asChild variant={'primary-foreground'} size={isDesktop ? 'default' : 'icon-md'}>
        <Link prefetch={false} href={attachment.url} target="_blank" rel="noopener noreferrer">
          <GoDownload size={18} />
          <span>{t('text717')}</span>
        </Link>
      </Button>
    </div>
  ));
}
